import classnames from 'classnames';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';

import { TermsContainer } from '../terms';
import { PageFooterContainer } from 'src/core/components/page-footer/page-footer';
import { SignEstimateContainer } from '../../sign-estimate/sign-estimate';

import styles from './terms.less';

interface Props {
    container: TermsContainer;
}

export const Terms = observer<React.SFC<Props>>(
    ({
        container: {
            estimate,
            bundleId,
            estimateId,
            showSignEstimate,
            closeSignEstimate,
            isSignEstimateOpen,
            termsHtml,
        },
    }) => (
        <div className="page">
            <div className="page-topping">
                <img className={styles.img} src="/assets/images/happy-illustration.svg" />
                <div className={styles.packageName}>{estimate && estimate.name}</div>
                <div className={classnames('page-title', styles.pageTitle)}>
                    <h2>Please review the terms below</h2>
                </div>
            </div>

            {estimate && estimate.termsSanitized && (
                <div
                    className={classnames('page-content', styles.pageContent)}
                    dangerouslySetInnerHTML={{ __html: termsHtml }}
                ></div>
            )}

            <div className="space-filler"></div>
            <div className="invoice-footer sticky-button-wrapper">
                <Button
                    className="next-step-button"
                    variant="contained"
                    color="primary"
                    onClick={showSignEstimate}
                >
                    Sign
                </Button>
            </div>
            {isSignEstimateOpen && (
                <SignEstimateContainer
                    bundleId={bundleId}
                    estimateId={estimateId}
                    closeSignEstimate={closeSignEstimate}
                />
            )}
            <PageFooterContainer />
        </div>
    )
);
